import { createFileRoute } from "@tanstack/react-router";
import Page from "@/components/Page";
import SystemContainer from "@/components/System/SystemContainer";

function SystemOverview() {
  return (
    <Page
      contentPadding
      maxWidth="xl"
      sx={{
        scrollbarGutter: "stable",
      }}
    >
      <SystemContainer />
    </Page>
  );
}

export const Route = createFileRoute("/_auth/_kontrollpunktselect")({
  component: SystemOverview,
});
